import { Box } from "@chakra-ui/react";
import { FragmentType, getFragmentData, gql } from "__generated__/gql";
import BrokerIcon from "components/Shared/BrokerIcon";
import TagList from "components/Shared/TagList";

const fragment = gql(/* GraphQL */ `
  fragment BrokerTagListItem on Broker {
    id
    name
    ...BrokerIcon
  }
`);

export type BrokerTagListItemFragment = FragmentType<typeof fragment>;

type Props = {
  brokers: BrokerTagListItemFragment[] | null | undefined;
};

export default function BrokerTagList({ brokers: brokersFragment }: Props) {
  const brokers = getFragmentData(fragment, brokersFragment);
  if (!brokers?.length) return null;
  return (
    <TagList
      items={brokers}
      getKey={(broker) => broker.id}
      getLabel={(broker) => (
        <Box display="inline-flex" alignItems="baseline" gap={1}>
          <BrokerIcon broker={broker} boxSize="1.1em" my={-1} top=".25em" />
          {broker.name}
        </Box>
      )}
      borderColor="gray.400"
      borderWidth={1}
      color="gray.600"
    />
  );
}
